import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100 justify-space-between" }

import { withDefaults, ref, onBeforeUnmount } from 'vue';
import CardData from './CardData.vue';
interface IProps {
  unity: string;
  operation: string;
  user: string;
  accommodation: string;
  hours: string;
  requestTimestamp: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTimeCard',
  props: {
    unity: { default: '' },
    operation: { default: '' },
    user: { default: '' },
    accommodation: { default: '' },
    hours: { default: '' },
    requestTimestamp: { default: '' }
  },
  setup(__props: any) {

const elapsedTime = ref<string>('');
let timer: number | undefined;

const getElapsedTime = (requestTime: string): string => {
  const now = new Date();
  const request = new Date(requestTime);
  const elapsed = now.getTime() - request.getTime();

  const totalMinutes = elapsed / (1000 * 60) | 0;
  const hours = (totalMinutes / 60) | 0;
  const minutes = totalMinutes % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

const props = __props;

const updateElapsedTime = () => {
  if (props.requestTimestamp) {
    elapsedTime.value = getElapsedTime(props.requestTimestamp);
  }
}

if (props.requestTimestamp !== '') {
  elapsedTime.value = getElapsedTime(props.requestTimestamp);
}

updateElapsedTime();
timer = window.setInterval(updateElapsedTime, 60000);

onBeforeUnmount(() => {
  clearInterval(timer);
});


return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mx-0 bg d-flex flex-column pa-7",
    height: "190",
    variant: "outlined"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CardData, {
          title_one: "Unidade",
          subtitle_one: props.unity,
          title_two: "Leito",
          subtitle_two: props.accommodation,
          hours: elapsedTime.value
        }, null, 8, ["subtitle_one", "subtitle_two", "hours"]),
        _createVNode(CardData, {
          title_one: "Atividade",
          subtitle_one: props.operation,
          title_two: "Paciente",
          subtitle_two: props.user
        }, null, 8, ["subtitle_one", "subtitle_two"])
      ])
    ]),
    _: 1
  }))
}
}

})